import { useRef } from "react";
import { TraceabilitySupplierViewModel } from "../../viewmodels/traceability/TraceabilitySupplierViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";

import TraceSupplierItem from "../../components/forms/traceability/TraceSupplierItem";
import IngredientSelector from "../../components/forms/traceability/IngredientSelector";
import EmptyModal from "../../components/modals/EmptyModal";
import { Skeleton } from "primereact/skeleton";

function TraceabilitySupplier(props) {
  const { logout } = props;
  const {
    loading,
    supplierReceivingGrouped,
    supplierTraceResult,
    supplierLotNumber,
    supplierIngredientId,
    reportLoading,
    slideOver,
    setSlideOver,
    onTraceSupplierByLot,
    onTraceSupplierByIngredient,
    onPrintTraceSupplierReceivingByLotAndIngredientReport,
    emptyModal,
    setEmptyModelOpen,
  } = TraceabilitySupplierViewModel(logout);

  const searchRef = useRef();

  const handleSearch = () => {
    onTraceSupplierByLot(searchRef.current?.value);
  };

  const renderTraceResults = function () {
    if (supplierTraceResult) {
      return (
        <TraceSupplierItem
          product={supplierTraceResult}
          lotNumber={supplierLotNumber}
          ingredientId={supplierIngredientId}
        />
      );
    }
    if (supplierReceivingGrouped?.receiving_items_grouped?.length > 0) {
      return (
        <IngredientSelector
          receivingItemsGrouped={
            supplierReceivingGrouped.receiving_items_grouped
          }
          lotNumber={supplierLotNumber}
          onSelectIngredient={(ingredientId) =>
            onTraceSupplierByIngredient(supplierLotNumber, ingredientId)
          }
        />
      );
    }
    if (
      supplierReceivingGrouped &&
      supplierReceivingGrouped.receiving_items_grouped?.length === 0
    ) {
      return (
        <div className="mt-4 p-4 card-custom text-gray-600">
          No trace found.
        </div>
      );
    }
    return null;
  };

  const hasSupplierResults =
    supplierTraceResult ||
    supplierReceivingGrouped?.receiving_items_grouped?.length > 0 ||
    (supplierReceivingGrouped &&
      supplierReceivingGrouped.receiving_items_grouped?.length === 0);
  const canPrintTraceReport =
    supplierTraceResult != null &&
    supplierIngredientId != null &&
    (supplierLotNumber || "").trim() !== "";

  return (
    <div>
      <div className="mt-2 lg:px-8">
        <div className="card-custom px-4 py-5">
          <div className="sm:flex sm:items-start sm:justify-between">
            <div>
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Trace Supplier Products
              </h1>
            </div>
            {canPrintTraceReport ? (
              <div className="mt-4 sm:mt-0 sm:ml-4">
                <button
                  type="button"
                  onClick={
                    onPrintTraceSupplierReceivingByLotAndIngredientReport
                  }
                  disabled={reportLoading || loading}
                  className="inline-flex items-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-60"
                >
                  {reportLoading ? "Generating..." : "Print"}
                </button>
              </div>
            ) : null}
          </div>
          <div className="mt-5 flex rounded-md">
            <div className="relative flex items-stretch flex-grow focus-within:z-10">
              <input
                type="search"
                name="searchProduct"
                id="searchProduct"
                className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                placeholder="Search by receiving lot number"
                ref={searchRef}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
            </div>
            <button
              type="button"
              className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
              onClick={() => handleSearch()}
            >
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
        {loading ? (
          <div className="py-4 space-y-4">
            <Skeleton
              className="w-full"
              height="5rem"
              borderRadius="16px"
            ></Skeleton>
            <Skeleton
              className="w-full"
              height="5rem"
              borderRadius="16px"
            ></Skeleton>
            <Skeleton
              className="w-full"
              height="5rem"
              borderRadius="16px"
            ></Skeleton>
            <Skeleton
              className="w-full"
              height="5rem"
              borderRadius="16px"
            ></Skeleton>
          </div>
        ) : hasSupplierResults ? (
          renderTraceResults()
        ) : null}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TraceabilitySupplier),
);
